import React from 'react'

export interface StarProps {
  id: string
  width?: number
  height?: number
  bg?: string
  fill?: string
  isPart?: number
  responsive?: boolean
}

export default function Star({
  id,
  width = 24,
  height = 24,
  bg = 'rgba(255,255,255, 0)',
  fill = 'currentColor',
  isPart,
  responsive = false,
}: StarProps) {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }
  return (
    <svg
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...svgAttributes}
    >
      <defs>
        <linearGradient id={id}>
          <stop offset={isPart ? `${isPart}0%` : '100%'} stopColor={fill} />
          {isPart && <stop offset={`${isPart}0%`} stopColor={bg} />}
        </linearGradient>
      </defs>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill={`url(#${id})`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  )
}
